export enum CoversSteps {
  Comprehensive = 0,
  Optional = 1,
  Activity = 2
}
